export function convertLocale (locale) {
  const localeArr = locale.replace('-', '_').split('_');
  return [localeArr[0], localeArr[1].toUpperCase()].join('_');
}

export function nextCharValue (lastAnswerValue) {
  var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var index = alphabet.indexOf(lastAnswerValue);
  if (index !== -1) {
    let currentCode = index + 1;
    return String.fromCharCode(64 + currentCode + 1);
  }
  return index;
}

export function getUpdateFieldsErrMsg (updateTitle, updateDescription, inProgress) {
  if (updateTitle && !updateDescription) {
    return 'Please also add a Course Update Description, or remove the Course Update Title to save.';
  }
  if (!updateTitle && updateDescription) {
    return 'Please also add a Course Update Title, or remove the Course Update Description to save.';
  }
  if (!updateTitle && !updateDescription && inProgress) {
    return 'Both Course Update Title and Course Update Description are required when In Progress is checked.';
  }
  return '';
}
